import React from 'react'

import * as S from './details-list.styled'

export type DetailsListProps = React.HTMLAttributes<HTMLDivElement>

export const DetailsList = (props: DetailsListProps) => <S.List {...props} />

export type DetailsListItemProps = React.HTMLAttributes<HTMLDivElement> & {
  label?: React.ReactNode
}

export const DetailsListItem = ({ label, children, ...props }: DetailsListItemProps) => (
  <S.Item {...props}>
    {label !== undefined && <span>{label}</span>}
    {children !== undefined && <S.Value>{children}</S.Value>}
  </S.Item>
)
